import { SERVICE_LINE_NAMES } from '../config.js';

import {
  getAddress as getLabsAddress,
  saveNewAddress as createLabsAddress,
  editAddress as editLabsAddress,
  removeAddress as removeLabsAddress,
} from '../services/lab-test.js';

import {
  fetchCartAddress as getPharmacyAddress,
  removeAddressCart as removePharmacyAddress,
} from '../services/medicine.js';

/**
 * Lab has all 4 APIs: get, create, edit, remove
 * Pharmacy has only 2 APIs get and remove; create and edit are used from Labs
 * Tele: uses Labs APIs only
 *
 * Backend gets data from same table, just the partner serviceability checks are different
 */
const COMMON = {
  apiFunction: getLabsAddress,
  removeApi: removeLabsAddress,
  createAddressFunction: createLabsAddress,
  editAddressFunction: editLabsAddress,
  addressIsSelectable: (ele) =>
    !('serviceable' in ele) || ele?.serviceable === true,
  addressIsUpdated: (ele) => ele.isLocationUpdated === true,
  autoSelectFirst: false,
  showBottomMessage: true, // bottom text under each address
  filterNonServiceable: false,
  filterNonUpdatedAddress: false,
};

export const ADDRESS_MODAL_CONFIG = {
  /**
   * Labs: get, remove, edit, create APIs
   */
  [SERVICE_LINE_NAMES.LABS]: { ...COMMON },
  /**
   * Pharmacy: Only has get and remove. Create and edit are used from labs.
   */
  [SERVICE_LINE_NAMES.PHARMACY]: {
    ...COMMON,
    apiFunction: getPharmacyAddress,
    removeApi: removePharmacyAddress,
    addressIsSelectable: (ele) => ele?.isServiceable === true,
  },
  /**
   * Tele: same as Labs
   */
  [SERVICE_LINE_NAMES.TELE]: {
    ...COMMON,
    autoSelectFirst: true, // confirm screen requires auto-selecting first address, if exists, to show in UI
  },
  /**
   * SearchAndBook: filter out non-serviceable addresses and non-updated addresses, do not show bottom message
   */
  [SERVICE_LINE_NAMES.SEARCHBOOK]: {
    ...COMMON,
    apiFunction: getPharmacyAddress,
    removeApi: removePharmacyAddress,
    showBottomMessage: false,
    filterNonServiceable: true,
    filterNonUpdatedAddress: true,
  },
};
